import { createApiError, normalizeToApiError } from "./error.service";
import { interceptorFetch } from "./interceptor.service";

export async function createLinkToken(token: string, updateToken: (newToken: string) => void) {
    try {
        const response = await interceptorFetch(`plaid/create_link_token`, token, updateToken, { method: "POST" });
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({ message: 'Invalid error response' }));
            throw createApiError(errorData, response.status);
        }

        return await response.json();

    } catch (error) {
        throw normalizeToApiError(error);
    }
}


export async function connectBankAccount(publicToken: string, employeeId: number, token: string, updateToken: (newToken: string) => void) {
    try {
        const response = await interceptorFetch(`plaid/connect-bank-account`, token, updateToken, {
            method: "POST",
            body: JSON.stringify({ publicToken, employeeId }),
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({ message: 'Invalid error response' }));
            throw createApiError(errorData, response.status);
        }

        return await response.json();

    } catch (error) {
        throw normalizeToApiError(error);
    }
}

